import { Connection } from 'rete'

import { CustomInput, CustomOutput } from '../../components'
import { FlowStatisticsMode } from '../Editor/types'

export class CustomConnection extends Connection {
  declare output: CustomOutput
  declare input: CustomInput

  declare data: {
    color: string | null,
    visible: boolean,
    d: string,
    id: number
    statistics: ConnectionStatisticsData
  }

  static LastConnectionId = 0

  constructor(output: CustomOutput, input: CustomInput) {
    super(output, input)
  }
}

export type ConnectionStatisticsData = UserConnectionStatistic | ConnectionStatistic | null

export type BaseConnectionStatistic = {
  value: number;
  inputKey: number
  outputKey: number
}

export type ConnectionStatistic = {
  criteria: FlowStatisticsMode.Users | FlowStatisticsMode.Steps
} & BaseConnectionStatistic

export type UserConnectionStatistic = {
  criteria: FlowStatisticsMode.User
  raw?: { output: number, input: number, times: Array<string> }
} & BaseConnectionStatistic

